import { cn } from "@utils/tw"
import { defineBlock, EditableText, useBlockContext, useInlineEditableValue } from "eddev/blocks"
import { useMembershipGridContext } from "../../contexts/MembershipGridContext"
import { Popover } from "@features/atoms/Popover"

export const meta: BlockMeta = {
  title: "Membership Grid Group Row",
}

const Cell = ({ children, className }: { children: React.ReactNode; className?: string }) => (
  <div
    className={cn("shrink-0 p-4 border-r border-blue-light last:border-none flex justify-start items-end", className)}
  >
    {children}
  </div>
)

const EditableCell = ({ membershipLevel, mode }: { membershipLevel: string; mode: "standard" | "premium" }) => {
  const standard = useInlineEditableValue("standard_" + membershipLevel, "-")
  const premium = useInlineEditableValue("premium_" + membershipLevel, standard[0])

  return (
    <div className="min-h-[1em]">
      <EditableText
        as="span"
        className={cn(mode === "premium" && "hidden")}
        store={standard}
        placeholder="-"
        plainText
      />
      <EditableText
        as="span"
        className={cn(mode === "standard" && "hidden")}
        store={premium}
        placeholder="-"
        plainText
      />
    </div>
  )
}

export default defineBlock("memberships/membership-grid-group-row", (props) => {
  const { levelModes } = useMembershipGridContext()
  const info = useBlockContext()
  const index = info?.index || 0
  const infoText = useInlineEditableValue("membershipGridGroupRowHeaderInfo", "")
  const showInfoText = (infoText[0] !== "" && infoText[0].length > 1) || env.admin

  return (
    <div className={cn("flex flex-nowrap shrink-0 items-center text-blue", index % 2 === 0 && "bg-white-tint")}>
      <Cell className="w-membershipGridCol1W type-body-xs px-2 self-stretch flex items-center gap-2">
        <EditableText store="membershipGridGroupRowHeader" placeholder="Example item text" />
        {showInfoText && (
          <Popover
            modal={false}
            trigger={
              <svg
                className="w-5 h-5 md:w-4 md:h-4 shrink-0 cursor-pointer"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.4167 3.25H3.25V12.4167H12.4167V3.25ZM3.25 2H12.4167H13.6667V3.25V12.4167V13.6667H12.4167H3.25H2V12.4167V3.25V2H3.25Z"
                  fill="#595959"
                />
                <path
                  d="M7.35265 6.52396H8.49132V11.2H7.35265V6.52396ZM7.33398 4.66663H8.50065V5.76796H7.33398V4.66663Z"
                  fill="#595959"
                />
              </svg>
            }
          >
            <EditableText
              as="span"
              store="membershipGridGroupRowHeaderInfo"
              className="type-body-xs"
              placeholder="Example optional info text"
              plainText
            />
          </Popover>
        )}
      </Cell>
      {levelModes.map((mode, i) => (
        <Cell key={i} className="w-membershipGridColW type-body-xs self-stretch flex items-center">
          <EditableCell membershipLevel={`level_${i}`} mode={mode} />
        </Cell>
      ))}
    </div>
  )
})
